import React from "react";
import styled from "styled-components";

import { Stem } from "@examspark/types";

import { useDrop } from "../../../common/drag/useDrag";

const Container = styled.div`
  border: dashed 2px #ddd;
  position: absolute;
  cursor: pointer;
  transition: border-color 0.2s;
  overflow: hidden;

  &:hover {
    border-color: #006699;
  }
`;

interface Props {
  data: Stem.Spot;
}

/**
 * Represents a `div` html element that accepts draggables.
 *
 * @param props
 */
const Droppable: React.FC<React.PropsWithChildren<Props>> = (props) => {
  const dropRef = useDrop({
    id: props.data.id,
  });

  return (
    <Container
      ref={dropRef}
      style={{
        left: props.data.coords.x,
        top: props.data.coords.y,
        width: props.data.coords.w,
        height: props.data.coords.h,
      }}
    >
      {props.children}
    </Container>
  );
};

export default Droppable;
